module.exports = __webpack_public_path__ + "img/cast_about_image1@2x.be508644.png";